import React from 'react'
const NavMenu =({children})=>{
    return(
        <div className="right" id="fp-nav1">
        <ul>{children}</ul>
        </div>
    )
}
export default NavMenu;